import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-otherApk",
  "use": "icon-otherApk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-otherApk\"><defs><style type=\"text/css\"></style></defs><path opacity=\"0.42\" d=\"M160 208h256v608H160z\" /><path opacity=\"0.42\" d=\"M232 736a32 32 0 1 0 64 0 32 32 0 1 0-64 0\" /><path d=\"M352 128h320v768H352z\" /><path d=\"M472 832a40 40 0 1 0 80 0 40 40 0 1 0-80 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/otherApk.svg
// module id = ++YR
// module chunks = 65